import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Redirect, useParams} from "react-router-dom";
import {
    handelChangeInputModalLoginAndRegister,
    handelOpenModalLoginAndRegister
} from "../../../../redux/actions/modals/modalLoginAndRegister";

const Introduced = () => {
    const {token} = useSelector(state => state.user);
    const dispatch = useDispatch();
    const params = useParams();

    useEffect(() => {
        if (!token && params.code) {
            dispatch(handelOpenModalLoginAndRegister());
            dispatch(handelChangeInputModalLoginAndRegister('introduced_code', params.code));
        }
        // eslint-disable-next-line
    }, []);

    return <Redirect to='/'/>;
}

export default Introduced;